module.exports = __webpack_public_path__ + "img/YALI_LOGO-1-wht.b6e34dba.png";